module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-image04-415x415@2x.a62d5da2.jpg";